import { render, staticRenderFns } from "./Ecert.vue?vue&type=template&id=3165fada&scoped=true"
import script from "./Ecert.vue?vue&type=script&lang=js"
export * from "./Ecert.vue?vue&type=script&lang=js"
import style0 from "./Ecert.vue?vue&type=style&index=0&id=3165fada&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165fada",
  null
  
)

export default component.exports